/**
 * Could one day be published as an external module?
 */
import ms from 'ms';

export default function VueNotifications(Vue) {
  if (VueNotifications.installed) {
    // Immediately return if this method has previously executed
    return;
  } else {
    VueNotifications.installed = true;
  }

  function mergeMessages({ message, prepend, append }) {
    return [ prepend, message, append ].filter(m => typeof m === 'string' && m.length).join('\n');
  }

  Vue.mixin({
    beforeCreate() {
      if (this.$options.notifications) {
        Object.keys(this.$options.notifications).forEach(name => {
          const defaultConfig = this.$options.notifications[name];
          this[name] = config => this.$notification({ ...defaultConfig, ...config });
        });
      }
    },
    methods: {
      $notification(config = {}) {
        const { message, ...opts } = {
          autoHideDelay: ms('5s'),
          solid: true,
          toaster: 'b-toaster-top-right',
          ...config,
        };

        return this.$bvToast.toast(message, opts);
      },
      $notifyErr(err, { prepend, append, ...config } = {}) {
        if (err && Array.isArray(err.graphQLErrors) && err.graphQLErrors.length) {
          err.graphQLErrors.forEach(gerr => {
            this.$notification({
              title: 'An error occurred',
              message: mergeMessages({ message: gerr.message, prepend, append }),
              variant: 'danger',
              ...config,
            });
          });
        } else if (err && err.networkError) {
          this.$notification({
            title: 'An error occurred',
            message: mergeMessages({ message: err.networkError.message, prepend, append }),
            variant: 'danger',
            ...config,
          });
        } else {
          this.$notification({
            title: 'An error occurred',
            message: mergeMessages({ message: err ? (err.message || `${err}`) : '', prepend, append }),
            variant: 'danger',
            ...config,
          });
        }
      },
      $notifyFatalErr(err, config = {}) {
        // this.$notifyErr(err, {
        //   toaster: 'b-toaster-top-center fatal-error',
        //   message: 'Please refresh this page, and check your Internet connection',
        //   autoHideDelay: ms('30s'),
        //   noAutoHide: false,
        //   noCloseButton: false,
        //   ...config,
        // });
        console.warn(err, 'Fatal error');
      },
    },
  });
};

export function notifyErr(config = {}) {
  return function (err) {
    this.$notifyErr(err, config);
  };
}



// WEBPACK FOOTER //
// ./src/plugins/vue-notifications.js